angular.module('bbl.services.socketio', [])
  .service('SocketUpdates', ['$rootScope', socketUpdatesService]);

function socketUpdatesService($rootScope) {
  var connected = false;
  var socket = io('/', {path: '/wss/'});

  socket.on('connect', function() { connected = true; });

  this.subscribeTo = function(companyId) {
    var cb = function() {socket.emit('subscribe', {company_id: companyId});};
    socket.on('connect', cb);

    if (connected) {
      cb();
    }
  };

  var events = [
    'conference:conference_locked',
    'conference:conference_ended',
    'call:caller_joined',
    'call:caller_left',
    'call:caller_muted',
    'call:caller_deafened',
    'call:caller_nudged',
    'call:name_recorded',
    'call:caller_raised_hand',
    'call:hand_raised_at',
    'call:caller_name_change',
    'floor:speaker_change',
    'sms:message_received',
  ];

  events.forEach(function(ev) {
    var d = ev.split(':');
    socket.on(d[1], function(data) {
      $rootScope.$broadcast('pusher:' + ev, data);
    });
  });
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/socket.io.js
 ** module id = 228
 ** module chunks = 0
 **/